import { defineStore } from 'pinia';
import { getContent } from '../../api/content/content';
import { ref, watch } from 'vue';
import { useStoreConfiguration } from '../configuration/configuration';
import { useStoreMainNavigation } from '../navigation/mainNav';
import type { NavContentTeaser } from '../../types/navContentTeaser';

export type StoreNavContent = {
  items?: {
    [key: string]: NavContentTeaser;
  };
};

const storeId = 'store-nav-content';

export const useStoreNavContent = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();
  const mainNav = useStoreMainNavigation();
  const items = ref<StoreNavContent['items']>();
  let contentUUID: string[];

  async function fetchItems() {
    if (!storeConfiguration.caasConfig || !storeConfiguration.config) {
      console.error(`${storeId} >>> error`, 'store configuration is not available');
      return;
    }

    if (!mainNav) {
      console.error(`${storeId} >>> error`, 'MainNavigation is not available');
      return;
    }

    if (mainNav.items && mainNav.items[0].children) {
      contentUUID =
        mainNav.items &&
        mainNav.items[0].children
          .map((child) => {
            return child.teaserId && child.teaserId;
          })
          .filter((children) => {
            return typeof children === 'string';
          });
    }

    if (!contentUUID?.length) {
      return;
    }

    const { caas_contentServiceUrl: contentServiceUrl } = storeConfiguration.config;
    const { project, instance, stage, locale, masterLocale, masterProject, prefix } =
      storeConfiguration.caasConfig;

    const contentItems = await getContent(
      storeConfiguration.caasUrl,
      contentServiceUrl,
      project,
      instance,
      contentUUID,
      stage,
      locale,
      masterLocale,
      masterProject,
      prefix,
      'store-nav-content',
    );

    if (contentItems) {
      items.value = contentItems;
    }
  }

  watch(storeConfiguration, () => {
    if (storeConfiguration.config && !items.value) {
      fetchItems();
    }
  });

  watch(mainNav, () => {
    if (mainNav.items && !items.value) {
      fetchItems();
    }
  });

  return {
    items,
  };
});
